import api from './api';

/**
 * Servicio para gestionar productos
 */
export const productosService = {
  /**
   * Obtener todos los productos
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {number} categoriaId - ID de la categoría para filtrar (opcional)
   * @param {string} buscar - Texto para buscar por SKU, nombre o código de barras (opcional)
   */
  getAll: async (empresaId = null, sucursalId = null, categoriaId = null, buscar = null) => {
    const params = {};
    if (empresaId) params.empresaId = empresaId;
    if (sucursalId) params.sucursalId = sucursalId;
    if (categoriaId) params.categoriaId = categoriaId;
    if (buscar) params.buscar = buscar;
    const response = await api.get('/productos', { params });
    return response;
  },

  /**
   * Obtener un producto por ID
   */
  getById: async (id) => {
    const response = await api.get(`/productos/${id}`);
    return response;
  },

  /**
   * Crear un nuevo producto
   */
  create: async (producto) => {
    const response = await api.post('/productos', producto);
    return response;
  },

  /**
   * Actualizar un producto
   */
  update: async (id, producto) => {
    const response = await api.put(`/productos/${id}`, producto);
    return response;
  },

  /**
   * Desactivar un producto (baja lógica)
   */
  delete: async (id) => {
    const response = await api.delete(`/productos/${id}`);
    return response;
  },

  /**
   * Actualizar precio de un producto para una sucursal específica
   * @param {number} productoId - ID del producto
   * @param {number} sucursalId - ID de la sucursal
   * @param {number} precioVenta - Nuevo precio de venta
   */
  updatePrecioSucursal: async (productoId, sucursalId, precioVenta) => {
    const response = await api.put(`/productos/${productoId}/precios-sucursal/${sucursalId}`, {
      PrecioVenta: precioVenta,
    });
    return response;
  },
};

